import React, { useCallback, useEffect, useRef, useState } from 'react'
import AddNewInsurancePayment from '../../MenuLayout/Navbar/NavbarComponents/QuickAddMenu/AddNewInsurancePayment';
import PatientPayments from '../../shared/PatientPayments/PatientPayments';
import { GeneralDropDowns } from '../../../actions/GeneralPatientActions';
import { useDispatch } from 'react-redux';
import { debounce } from 'lodash'
import AddNewTask from '../../Home/TaskManagement/AddNewTask';
import AddNewUser from '../../Setup/UserManagement/User/AddNewUser';
import AddNewAppointment from '../../Scheduler/AddNewAppointment';
import AddNewProvider from '../../Setup/Account/Provider/AddNewProvider';
import { useSelector } from 'react-redux';
import ContentReceiver from '../../MenuLayout/ContentReceiverNewBrowserTab/ContentReceiver';
import OpenQuickPopup from '../../shared/OpenQuickPopup/OpenQuickPopup';
import AddNewLocation from '../../Setup/Account/Location/AddNewLocation';
import AddNewInsurance from '../../Setup/InsuranceM/Insurance/AddNewInsurance';
import AddNewTicket from '../../Support/AddNewTicket';
import { ServerRequestProtected } from '../../../utils/ServerDataRequest';
import { enumUtil } from '../../../utils/Enum';
import { removeSignalRConnection } from '../../../actions/SignalRhubs';
import { useNavigate } from 'react-router-dom';
import NotificationHandler from '../../../utils/NotificationHandler';
import { UserLogout } from '../../../actions/LoginAction';
const ShortcutKeysWrapper = ({ children }) => {
    const dispatch = useDispatch();
    let GenDD = useSelector(state => state.GeneralDropDownsReducer);
    let SideBarActiveKey = useSelector(state => state.SidebarActiveTab);
    const [addNewInsurancePayment, setAddNewInsurancePayment] = useState(false);
    const [addNewPatientPayment, setAddNewPatientPayment] = useState(false);
    const [addNewTask, setAddNewTask] = useState(false);
    const [addNewUser, setAddNewUser] = useState(false);
    const [addNewAppointment, setAddNewAppointment] = useState(false);
    const [addNewProvider, setAddNewProvider] = useState(false);
    const [openTab, setOpenTab] = useState('');
    const API_URL = enumUtil.controller.Login
    const navigate = useNavigate()

    const handleObjData = (name, type) => {
        let data = {};
        if (type === 'Patient') {
            data = { id: -1, name: "New Patient" }

            dispatch(GeneralDropDowns({
                ...GenDD, DisCardActiveIds: {
                    ...GenDD?.DisCardActiveIds,
                    Patient: [...GenDD?.DisCardActiveIds?.Patient, {
                        isDemographicsOpened: false,
                        isDemographicsUpdated: false,
                        isInsuranceOpened: false,
                        isInsuranceUpdated: false,
                        PatientID: -1,
                    }]
                }

            }))
        } else if (type === 'Professional Claims') {
            data = { name: "New Professional", id: -1, visitType: "P" }
        } else if (type === 'Institutional Claims') {
            data = { name: "New Institutional", id: -2, visitType: "I" }
        }
        // }else if(type==='Insurance Payment'){data={ id: -1,name: "New Insurance Payments",checkType:"Manual",paymentType:"Insurance"}}
        setOpenTab({
            key: 2,
            active: true,
            name: name,
            data: {
                time: new Date(),
                ...data
            },
        });
    }

    const openAddPatientPaymentPopup = () => {
        setAddNewPatientPayment(true);
    }
    const OnCloseAddPaymentPopup = () => {
        setAddNewPatientPayment(false);
    }

    let PtPaymentPopup = '';
    if (addNewPatientPayment) {
        PtPaymentPopup = <PatientPayments isOpenPatientPayments={addNewPatientPayment} OnClosePtPayment={OnCloseAddPaymentPopup} PatientID='' type={'Payment'} ID={'0'} />
    }

    const openAddTaskPopup = () => {
        setAddNewTask(true);
    }
    const OnCloseTaskPopup = () => {
        setAddNewTask(false);
    }
    let TaskPopup = '';
    if (addNewTask) {
        TaskPopup = <AddNewTask IsOpen={addNewTask} IsClosed={OnCloseTaskPopup} onDeleteTask={OnCloseTaskPopup} Task={0} />
    }

    const openAddUserPopup = () => {
        setAddNewUser(true);
    }
    const OnCloseUserPopup = () => {
        setAddNewUser(false);
    }
    let UserPopup = '';
    if (addNewUser) {
        UserPopup = <AddNewUser isOpenUser={addNewUser} onClose={OnCloseUserPopup} onCloseSave={OnCloseUserPopup} onDeleteUser={OnCloseUserPopup} UserID={0} />
    }

    const openAddAppointmentPopup = () => {
        setAddNewAppointment(true);
    }
    const OnCloseAppointmentPopup = () => {
        setAddNewAppointment(false);
    }
    let ApptPopup = '';
    if (addNewAppointment) {
        ApptPopup = <AddNewAppointment AppointmentID={0} showEvents={addNewAppointment} handleOnClose={OnCloseAppointmentPopup} />;
    }

    const openAddProvider = () => {
        setAddNewProvider(true);
    }
    const OnCloseProviderPopup = () => {
        setAddNewProvider(false);
    }
    let ProvPopup = '';
    if (addNewProvider) {
        ProvPopup = <AddNewProvider isOpenProvider={addNewProvider} onClose={OnCloseProviderPopup} onDeleteProvider={OnCloseProviderPopup} ProviderID={0} />
    }
    const [isOpenLocation, setIsOpenLocation] = useState(false)
    const openLocation = () => {
        setIsOpenLocation(true);
    }
    const closeLocation = () => {
        setIsOpenLocation(false);
    }
    let LocationPopup = '';
    if (isOpenLocation) {
        LocationPopup = <AddNewLocation isOpenLocation={isOpenLocation} onClose={closeLocation} onDeleteLocation={closeLocation} LocationID={0} />
    }
    const [isOpenInsurance, setIsOpenInsurance] = useState(false)
    const openInsurance = () => {
        setIsOpenInsurance(true);
    }
    const closeInsurance = () => {
        setIsOpenInsurance(false);
    }
    let InsurancePopup = '';
    if (isOpenInsurance) {
        InsurancePopup = <AddNewInsurance IsOpenInsurance={isOpenInsurance} onClose={closeInsurance} onDeleteLocation={closeInsurance} InsuranceID={0} />
    }


    const [isOpenTicket, setIsOpenTicket] = useState(false)
    const openTicket = () => {
        setIsOpenTicket(true);
    }
    const OnCloseTicket = () => {
        setIsOpenTicket(false);
    }
    let Ticketopup = '';
    if (isOpenTicket) {
        Ticketopup = <AddNewTicket IsOpen={openTicket} IsClosed={OnCloseTicket} onDeleteTask={OnCloseTicket} Ticket={0} />
    }

    const toggleSidebar = () => {
        var getScreenWidth = window.innerWidth
        // console.log("toggleSidebar")
        if (getScreenWidth > 992) {
            document.body.classList.toggle("sidebar-slim")
        }
        if (getScreenWidth > 600 && getScreenWidth < 992) {
            if (document.body.classList.contains("tablet")) {
                document.body.classList.toggle("sidebar-slim")
            }
        }
        if (getScreenWidth < 600) {
            if (document.body.classList.contains("mobile")) {
                document.body.classList.toggle("sidebar-mobile-open")
            }
        }
    }
    const handleLogout = () => {
        ServerRequestProtected(API_URL + "/Logout", 'post', {})
            .then((response) => {
                dispatch(removeSignalRConnection('NotificationsHub'));
                navigate("../", { replace: true })
                NotificationHandler("Logged Out", enumUtil.enumtoaster.success)
                dispatch(UserLogout());
            }).catch((error) => { })
    }
    const handleGlobalSearch = (type) => {
        if (type === 'Patient') {
            dispatch(GeneralDropDowns({ ...GenDD, isGLobalSearchFocused: 'Patient' }))
        } else if (type === 'Billing') {
            dispatch(GeneralDropDowns({ ...GenDD, isGLobalSearchFocused: 'Billing' }))
        } else if (type === 'Profile') {
            dispatch(GeneralDropDowns({ ...GenDD, isGLobalSearchFocused: 'Profile' }))
        }
    }
    const comboKeys = useRef([]); // ✅ Holds current key sequence
    const isInputFocused = () => {
        const activeElement = document.activeElement;
        return (
            activeElement.tagName === 'INPUT' ||
            activeElement.tagName === 'TEXTAREA' ||
            activeElement.tagName === 'SELECT' ||
            activeElement.isContentEditable
        );
    };
    const executeCombo = useCallback(
        debounce(() => {
            if (isInputFocused()) {
                comboKeys.current = []; // Clear combo if input is focused
                return;
            }
            const sequence = comboKeys.current.join('+');
            if (sequence === 'a+p') {                                                           //          ADD PATIENT
                handleObjData("Patient", "Patient")
            } else if (sequence === 'a+a') {                                                    //          ADD APPOINTMENT 
                openAddAppointmentPopup();
            } else if (sequence === 'p+c') {                                                    //          ADD PROFESSIONAL CLAIM 
                handleObjData("Claims", "Professional Claims");
            } else if (sequence === 'i+c') {
                handleObjData("Claims", "Institutional Claims")                                 //          ADD INSTITUTIONAL CLAIM
            } else if (sequence === 'i+p') {                                                    //          ADD INSURANCE PAYMENT
                setAddNewInsurancePayment(true)
            } else if (sequence === 'p+p') {                                                    //          ADD PATIENT PAYMENT
                openAddPatientPaymentPopup();
            } else if (sequence === 'a+u') {                                                    //          ADD USER
                openAddUserPopup()
            } else if (sequence === 'a+r') {                                                    //          ADD PROVIDER
                openAddProvider()
            } else if (sequence === 'a+l') {                                                    //          ADD LOCATION
                openLocation()
            } else if (sequence === 'a+i') {
                openInsurance()                                                                 //          ADD INSURANCE
            } else if (sequence === 'a+t') {                                                    //          ADD TASK
                openAddTaskPopup();
            } else if (sequence === 'c+t') {                                                    //          CREATE TICKET          
                openTicket();
            } else if (sequence === '/') {                                              //          Toggle sidebar
                toggleSidebar()
            } else if (sequence === 'l') {                                                  //          Logout
                handleLogout()
            } else if (sequence === 's+p') {                                                    //          Global Search
                handleGlobalSearch('Patient')
            } else if (sequence === 's+b') {                                                    //          Global Search
                handleGlobalSearch('Billing')
            } else if (sequence === 's+p+r') {                                                    //          Global Search
                handleGlobalSearch('Profile')
            }
            else {
                console.log('Unrecognized combo:', sequence);
            }
            comboKeys.current = []; // ✅ Clear combo after handling

        }, 500), [GenDD])

    useEffect(() => {
        const handleKeyDown = (event) => {
            // if (!event.altKey) return;
            if (isInputFocused()) {
                return;
            }
            const key = event.key.toLowerCase();
            // if (['a', 'p', 'c', 'i', 't', 'u', 'r', 'l', 'g', 's', 'alt', '/'].includes(key)) {
            //     event.preventDefault();
            //     event.stopPropagation();
            // }
            comboKeys.current.push(key);
            executeCombo(); // Debounced logic
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            executeCombo.cancel(); // ✅ Clean up debounce
        };
    }, [executeCombo]);

    return (
        <React.Fragment>
            {Ticketopup}
            {LocationPopup}
            {InsurancePopup}
            {PtPaymentPopup}
            {TaskPopup}
            {UserPopup}
            {ApptPopup}
            {ProvPopup}
            <AddNewInsurancePayment addNewInsurancePayment={addNewInsurancePayment} setAddNewInsurancePayment={setAddNewInsurancePayment} />
            {openTab ? <ContentReceiver data={openTab} setOpenTab={setOpenTab} /> : <></>}
            {children}
        </React.Fragment>
    )
}

export default ShortcutKeysWrapper
